exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-tip[data-v-09e27d08]{position:fixed;top:0;left:0;width:100%;z-index:500;font-size:.14rem;text-align:center;padding:.075rem;color:#fff;background:rgba(239,167,35,.95)}.top-tip.drop-enter-active[data-v-09e27d08],.top-tip.drop-leave-active[data-v-09e27d08]{-webkit-transition:all .5s;transition:all .5s}.top-tip.drop-enter[data-v-09e27d08],.top-tip.drop-leave-to[data-v-09e27d08]{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}", ""]);

// exports
